import $ from "jquery"
import { trace } from "./../shared/helpers.js"

const Showmore = {
  init() {
    let less = $('.collapseText-button').data("labelexpanded");
    let more = $('.collapseText-button').data("labelcollapsed");

    $('#collapseText').on('hidden.bs.collapse', function () {
      $('#moreorless').text(more);
    });
    $('#collapseText').on('shown.bs.collapse', function () {
      $('#moreorless').text(less);
    });
  }
}

export default Showmore;
